import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getTask, postTask } from '../../services';
import { Urls } from '../../config/urls';

export interface ThreeDSecureCountryInfo {
  country: string;
  available: boolean;
  cost: number;
  enabled: boolean;
  forced?: boolean;
  coverage: 'LOW' | 'MEDIUM' | 'HIGH';
}

export function useThreeDSecureInfo() {
  const [data, setData] = useState<ThreeDSecureCountryInfo[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { auth } = useSelector((state: any) => state);

  const fetchData = useCallback(async () => {
    if (!auth.token) {
      return;
    }
    setLoading(true);
    setError(false);
    const result = await getTask({
      url: Urls.api.threeDSecureInfo,
      token: auth.token,
    });
    if ('response' in result && result.response) {
      setData(result.response as ThreeDSecureCountryInfo[]);
    } else {
      setError(true);
    }
    setLoading(false);
  }, [auth.token]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const toggleCountry = async (country: string, enabled: boolean) => {
    const url = (enabled ? Urls.api.enableThreeDSecureCountry : Urls.api.disableThreeDSecureCountry).replace(
      ':country',
      country,
    );
    const previous = data;
    setData(current => current.map(row => (row.country === country ? { ...row, enabled } : row)));
    const result = await postTask({
      url,
      body: {},
      token: auth.token,
    });
    if (!('response' in result) || !result.response) {
      setData(previous);
    }
  };

  return { data, loading, error, toggleCountry };
}
